/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatalistAnagrafica, Paginator, SortingDirectionEnum, Utente } from '@models';
import { UtenteService } from '@shared/services/utente.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-utente-approva-utente',
    templateUrl: './approva-utente.component.html',
})
export class PagesGestioneUtenteApprovaUtenteComponent implements OnInit {
    
    public tableData: Utente[] = [];
    public paginator: Paginator = new Paginator();
    public datalist: DatalistAnagrafica;

    constructor(
        private utenteService: UtenteService,
        private utilsService: UtilsService,
        private route: ActivatedRoute,
    ) { }
    
    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.tableData = this.route.snapshot.data['additionalInformation'].items.content;
        this.paginator.setTotalPage(this.route.snapshot.data['additionalInformation'].items.totalElements);
    }

    public onPageChange($event: number) {
        this.paginator.page = $event;
        this.loadData();
    }

    public validazione(azione: string, id: number) {
        this.utenteService.validazione(azione, id).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.loadData();
            }
        });
    }

    private loadData() {
        this.utenteService.getInApprovazione(this.paginator.getQueryPaginator([{ field: 'id', direction: SortingDirectionEnum.DESC }])).subscribe(response => {
            this.tableData = response.content;
            this.paginator.setTotalPage(response.totalElements);
        });
    }

}
